import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import b64toBlob from "b64-to-blob";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import USA_visLogo from "../../assets/USA_Images/login_images/App-logo.svg";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";

function SelfRegistrationCheckList(props) {
  const location = useLocation();
  const { t } = useTranslation();
  const history = useHistory();

  const [checkListItems, setCheckListItems] = useState([]);
  const [checkListAnswers, setCheckListAnswers] = useState(
    JSON.parse(localStorage.getItem("checklistItems")),
  );
  const videoAcknowledgement = props?.location?.state?.videoAcknowledgement;

  const convertBase64toBlob = () => {
    var base64Data = localStorage.getItem("profileImage");
    if (base64Data) {
      var contentType = "image/jpeg";
      var blob = b64toBlob(base64Data, contentType);
      return blob;
    }
    return null;
  };
  const [profileImage, setProfileImage] = React.useState(convertBase64toBlob());
  const handleChange = (event) => {
    checkListAnswers.map((question) => {
      if (question.Question === event.target.name) {
        question.Answers = event.target.value;
      }
    });
  };

  const config = {
    headers: { companyId: localStorage.getItem("companyId") },
  };

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("checklistItems"));
    setCheckListItems(items || []);

    const checkListQuestions = (items || []).map((item) => ({
      Question: item.question,
      Answers: "",
    }));

    setCheckListAnswers(checkListQuestions);
  }, []);

  const handleSubmit = () => {
    var error = false;
    var isAnswersMatched = false;
    checkListItems.map((question) => {
      if (error) return;
      checkListAnswers.map((expertedAnswer) => {
        if (question.question === expertedAnswer.Question) {
          if (
            question.mandatory !== "No" &&
            CommonUtil.isEmpty(expertedAnswer.Answers)
          ) {
            Toast("Please answer mandatory questions", "error");
            return;
          }
        }
      });
    });

    if (error) {
      return;
    }

    checkListItems.map((question) => {
      if (isAnswersMatched) return;
      checkListAnswers.map((expertedAnswer) => {
        if (question.mandatory === "Yes") {
          if (question.question === expertedAnswer.Question) {
            if (
              question.expertedAnswer.toLowerCase() !==
              expertedAnswer.Answers.toLowerCase().trim()
            ) {
              Toast(t("CHECK_LIST_MISMATCH"), "error");
              localStorage.clear();
              history.push({
                pathname: "/vis/confirms-page/rejects",
                state: { cancel: true },
              });
              isAnswersMatched = true;
            }
          }
        }
      });
    });
    if (isAnswersMatched) {
      return;
    }
    if (!error) {
      history.push({
        pathname: "/vis/selfRegistration/NDA",
        data: JSON.parse(localStorage.getItem("payload")),
        config: config,
        profileImage: profileImage,
        videoAcknowledgement: videoAcknowledgement,
      });
    }
    // else if (!error && videoAcknowledgement) {
    //   history.push({
    //     pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION,
    //   });
    // }
  };

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#F4F6F8",
        }}
      >
        <Grid container alignItems="center">
          <Grid item className="logo-center">
            <img src={USA_visLogo} alt="logo" style={{ width: "180px" }} />
          </Grid>
        </Grid>
      </Grid>
      <Paper>
        <Typography
          gutterBottom
          variant="h3"
          style={{ padding: "25px", paddingLeft: "75px" }}
        >
          {t("CHECK_LIST_HEADER")}
        </Typography>
        <Grid container p={5} spacing={3}>
          <Grid item xs={12} sm={12}>
            <Grid container direction="row">
              {checkListItems.length > 0 &&
                checkListItems.map((checkList, index) => {
                  return (
                    <Grid item xs={12} sm={6}>
                      <Box
                        display="flex"
                        p={2}
                        marginLeft={"20px"}
                        marginRight={"20px"}
                      >
                        {index + 1 + ". "}{" "}
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            {checkList.question +
                              (checkList.mandatory !== "No" ? " *" : "")}
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-label="gender"
                            name={checkList.question}
                            onChange={handleChange}
                          >
                            {checkList?.options.map((data) => {
                              const splittedData = data.split(",");
                              if (splittedData?.length >= 0) {
                                let options = [];
                                splittedData.map((option) =>
                                  options.push(
                                    <FormControlLabel
                                      value={option}
                                      control={<Radio />}
                                      label={option}
                                    />,
                                  ),
                                );
                                return options;
                              }
                            })}
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Box display="flex" sx={{ m: 1 }}>
            <SubmitButtons
              sx={{ m: 1 }}
              onClick={handleSubmit}
              variant="contained"
            >
              <Typography>{t("CONTINUE_BUTTON")}</Typography>
            </SubmitButtons>
          </Box>
        </Grid>
      </Paper>
    </>
  );
}

export default SelfRegistrationCheckList;
